/* eslint-disable react/no-array-index-key */
import React from 'react';
import moment from 'moment';
import { Box } from '@mui/system';
import { MenuItem, Select, Stack, Typography } from '@mui/material';
import DayPickerSingleDateControllerWrapper from './DayPickerSingleDateControllerWrapper';

const NewCalendar = (props) => {
  const { selectDate, calendarData, robotData, handleSelectDate } = props;
  const datePicker = ({ month, onMonthSelect, onYearSelect }) => {
    const pickDate = moment({ year: month.year(), month: month.month() });
    return (
      <Stack direction="row" gap={1} justifyContent="center">
        <Select
          value={month.year()}
          onChange={(e) => {
            onYearSelect(month, e.target.value);
            handleSelectDate(
              moment({
                year: e.target.value,
                month: pickDate.get('month'),
              }),
            );
          }}
          sx={{ height: '33px', '& .MuiOutlinedInput-input': { py: 0 } }}
        >
          <MenuItem value={pickDate.year() - 1}>{pickDate.year() - 1}</MenuItem>
          <MenuItem value={pickDate.year()}>{pickDate.year()}</MenuItem>
          <MenuItem value={pickDate.year() + 1}>{pickDate.year() + 1}</MenuItem>
        </Select>
        <Select
          value={month.month()}
          onChange={(e) => {
            onMonthSelect(month, e.target.value);
            handleSelectDate(
              moment({
                year: pickDate.get('year'),
                month: parseInt(e.target.value, 10),
              }),
            );
          }}
          sx={{ height: '33px', '& .MuiOutlinedInput-input': { py: 0 } }}
        >
          {moment.months().map((label, value) => (
            <MenuItem value={value} key={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    );
  };
  const renderDayContents = (dayMoment) => {
    const day = dayMoment.get('date') - 1;
    return (
      <Box
        display="flex"
        flexFlow="column"
        sx={{ height: '100%', width: '100%', maxHeight: '65px' }}
      >
        <Typography sx={{ ml: 0.5, mt: 0.5, letterSpacint: '-1px' }}>
          {dayMoment.format('D')}
        </Typography>
        {calendarData[day] && calendarData[day].length > 0 && (
          <Box
            display="inline-flex"
            sx={{ flexWrap: 'wrap', pt: 1, pl: 0.5 }}
            gap={0.5}
          >
            {calendarData[day].map(
              ({ id, className, name }) =>
                robotData[id].checked && (
                  <span
                    key={`${dayMoment.format('YYYYMMDD')}_${name}`}
                    className={className}
                    style={{
                      width: '10px',
                      height: '10px',
                      borderRadius: '5px',
                    }}
                  />
                ),
            )}
          </Box>
        )}
      </Box>
    );
  };
  return (
    <DayPickerSingleDateControllerWrapper
      initialDate={selectDate}
      numberOfMonths={1}
      daySize={65}
      weekDayFormat="ddd"
      renderDayContents={renderDayContents}
      renderMonthElement={datePicker}
      onChange={handleSelectDate}
    />
  );
};

export default NewCalendar;
